import React from "react";
import {
  Box,
  Container,
  Typography,
  useTheme,
  Stack,
  Paper,
} from "@mui/material";
import {
  EmojiEvents as TrophyIcon,
  School as EducationIcon,
  FitnessCenter as FitnessIcon,
  Star as StarIcon,
  Verified as VerifiedIcon,
  ChevronRight as ChevronRightIcon,
  TrendingUp as TrendingUpIcon,
  People as PeopleIcon,
} from "@mui/icons-material";
export default function CoachPolicy() {
  const theme = useTheme();
  // Trainer policies
  const trainerPolicies = [
    {
      icon: <VerifiedIcon sx={{ fontSize: 28 }} />,
      title: "تایید صلاحیت",
      items: [
        "مدارک معتبر بین‌المللی",
        "کارت مربیگری رسمی",
        "بیمه مسئولیت مدنی",
      ],
      color: theme.palette.error.main,
    },
    {
      icon: <EducationIcon sx={{ fontSize: 28 }} />,
      title: "سابقه و تجربه",
      items: [
        "حداقل ۵ سال تجربه",
        "سابقه قهرمانی یا همکاری با تیم‌های ملی",
        "مدارک آموزشی به‌روز",
      ],
      color: theme.palette.secondary.main,
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 28 }} />,
      title: "رضایت مشتریان",
      items: [
        "امتیاز بالای ۴.۵",
        "بازخوردهای مثبت",
        "تعداد جلسات برگزار شده > ۱۰۰۰",
      ],
      color: theme.palette.success.main,
    },
  ];
  const policyItems = trainerPolicies.map((policy, idx) => (
    <Paper
      key={idx}
      elevation={0}
      sx={{
        flex: 1,
        p: 2.5,
        borderRadius: 4,
        border: `1px solid ${policy.color}20`,
        bgcolor: `${policy.color}04`,
        transition: "all 0.3s ease",
        "&:hover": {
          borderColor: `${policy.color}60`,
          transform: "scale(1.02)",
          boxShadow: `0 8px 24px ${policy.color}20`,
        },
      }}
    >
      <Stack direction="row" sx={{ gap: "8px" }} alignItems="flex-start">
        <Stack
          sx={{
            p: 1,
            borderRadius: 2,
            bgcolor: `${policy.color}15`,
            color: policy.color,
          }}
        >
          {policy.icon}
        </Stack>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
            {policy.title}
          </Typography>
          <Stack spacing={0.75}>
            {policy.items.map((item, i) => (
              <Stack
                key={i}
                direction="row"
                alignItems="center"
                sx={{ gap: "4px" }}
              >
                <Box
                  sx={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    bgcolor: policy.color,
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  {item}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Paper>
  ));
  return (
    <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
      {/* Partnership Policies Section - New Design */}
      <Box>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 1,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            معیارهای همکاری با مربیان
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ما فقط با مربیانی همکاری می‌کنیم که این استانداردها را داشته باشند
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", lg: "row" }}
          // spacing={2.5}
          justifyContent="center"
          sx={{ gap: "16px" }}
        >
          {policyItems}
        </Stack>
      </Box>

      {/* Bottom Trust Badge */}
      <Paper
        sx={{
          mt: 5,
          p: 2,
          borderRadius: 4,
          bgcolor: `${theme.palette.info.main}08`,
          border: `1px dashed ${theme.palette.info.main}40`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <VerifiedIcon sx={{ color: theme.palette.info.main }} />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          تمامی مربیان ما به صورت دوره‌ای ارزیابی می‌شوند و گواهی‌های معتبر
          بین‌المللی دارند
        </Typography>
      </Paper>
    </Container>
  );
}
